import React from 'react';
import Bodenfeuchte from '../components/Bodenfeuchte';
import './home.css'; // gleiche Styles wie bei Home verwenden

function BodenfeuchteFuerstenfeld() {
  return (
    <div
      className="home-container"
      role="main"
      aria-labelledby="bodenfeuchte-fuerstenfeld-heading"
    >
      <div className="home-diagramm">
        <div className="wetter-container">
          <h1 id="bodenfeuchte-fuerstenfeld-heading">BODENFEUCHTE</h1>
        </div>

        <Bodenfeuchte ort="fuerstenfeld" />
      </div>
    </div>
  );
}

export default BodenfeuchteFuerstenfeld;
